import {filters} from "../filters";
import breadIcon from '../../components/Svg/breadscrumbs'
import dotsIcon from '../../components/Svg/sidebar/dots'
import trimItem from '../../components/trimITem'
import {tokenAndRoute} from "../utils/tokenAndRoute";

export const breadcrumbsMixin = {
  mixins: [tokenAndRoute, filters],
  components: {
    breadIcon,
    dotsIcon,
    trimItem
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    name() {
      return this.$store.state.sidebar.routeName
    }
  }

};
